module.exports = __webpack_public_path__ + "img/SSL-opti.07d971e6.png";